// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__120in","requiredAsterisk":"Info_requiredAsterisk__3eBuA"};